import { Auth0Token } from '../types';

export const getUserPermissions = (
    decodedToken: Auth0Token | null
): string[] => {
    return Array.from(
        new Set(
            [
                ...(decodedToken?.scope || '').split(' '),
                ...(decodedToken?.permissions || []),
            ]
                .map((scope) => scope.trim())
                .filter(Boolean)
        )
    );
};
